const state = {
  activeSignInLink: '',
  showSignInButton: false,
  showGetStartedButton: true,
  showMenu: true,
  selectedProducts: ['cre_analytics'],
};

export default state;
